import { Component } from '@angular/core';
import { App,LoadingController} from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';
import { HttpService } from '../../../../../providers/service/httpservice';
import { UNIFIEDADDRESSBOOKLIST } from '../../../../../providers/config/serviceurl';

@Component({
  selector: 'unifiedaddressbook-list',
  templateUrl: 'unifiedaddressbooklist.html'
})

export class UnifiedAddressBookList {
	pageIndex = 1;
	pageNumber = 20;
	params:any=[];
	public loading;
	unifiedAddressBookList:any=[];
	constructor(public global: AppState,public appCtrl: App,private loadCtrl:LoadingController,private httpService:HttpService) {
		this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber};
		this.loadData(this.params);
	}
	
	loadData(params){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
	  this.httpService.post(UNIFIEDADDRESSBOOKLIST,params).then(anyObj =>this.handleList(anyObj));
	  this.loading.dismiss();//加载动画结束
	}
	
	search($keyword){
		let keyword = $keyword.value;
		this.pageIndex = 1;
		this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'str':keyword};
		this.unifiedAddressBookList=[];
		this.httpService.post(UNIFIEDADDRESSBOOKLIST,this.params).then(anyObj =>this.handleList(anyObj));
	}
	
	handleList(obj:any){
  	if(obj){
  		var length = obj.length;
  		for(var i=0;i<length;i++){
  			this.unifiedAddressBookList.push(obj[i]);
  		}
		}
  }
	
	getList(params){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		this.httpService.post(UNIFIEDADDRESSBOOKLIST,params).then(anyObj =>this.handleList(anyObj));
		this.loading.dismiss();//加载动画结束
	}
	
	//上拉加载
	loadMore($keyword,refresher){
		setTimeout(() => {
			this.pageIndex++;
			this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'str':$keyword.value};
			this.getList(this.params);
	    refresher.complete();
	  }, 500);
	}
	
	//下拉刷新
  doRefresh($keyword,refresher){
	  setTimeout(() => {
		 	this.pageIndex = 1;
		 	this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'str':$keyword.value};
			this.unifiedAddressBookList=[];
		 	this.getList(this.params);
			refresher.complete();
	  }, 1000);
  }
}


// WEBPACK FOOTER //
// ./src/pages/application/dailyoffice/unifiedaddressbook/list/unifiedaddressbooklist.ts